import { toast } from "react-toastify";
import * as types from "./actionTypes";
import { apiLoadingStart, apiLoadingStop } from "../../../../../Store/global";
import ApiList from "../webservice/ApiList";

export const resetStore = () => ({
  type: types.RESET_STORE_USER,
});

export const getStreetLightAction = () => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.STREET_LIGHT_REQUEST });

    try {
      const response = await ApiList.getStreetLight();
      // console.log('response', response)
      if (response) {
        dispatch({
          type: types.STREET_LIGHT_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({ type: types.STREET_LIGHT_ERROR, payload: response.status });
      }
    } catch (error) {
      dispatch({
        type: types.STREET_LIGHT_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const getStreetLightDetailsAction = (uuid) => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.STREET_LIGHT_DETAIL_REQUEST });

    try {
      const response = await ApiList.getStreetLightDetails(uuid);
      if (response) {
        dispatch({
          type: types.STREET_LIGHT_DETAIL_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({
          type: types.STREET_LIGHT_DETAIL_ERROR,
          payload: response.status,
        });
      }
    } catch (error) {
      dispatch({
        type: types.STREET_LIGHT_DETAIL_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const getStreetLightHistoryAction = (uuid) => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.STREET_LIGHT_HISTORY_REQUEST });

    try {
      const response = await ApiList.getStreetLightHistory(uuid);
      if (response) {
        dispatch({
          type: types.STREET_LIGHT_HISTORY_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({
          type: types.STREET_LIGHT_HISTORY_ERROR,
          payload: response.status,
        });
      }
    } catch (error) {
      dispatch({
        type: types.STREET_LIGHT_HISTORY_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};
export const createStreetLightAction = (request) => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.CREATE_STREET_LIGHT_REQUEST });

    try {
      const response = await ApiList.createStreetLight(request);

      if (response) {
        dispatch({
          type: types.CREATE_STREET_LIGHT_SUCCESS,
          payload: response,
        });
      } else {
        dispatch({
          type: types.CREATE_STREET_LIGHT_ERROR,
          payload: response.status,
        });
      }
    } catch (error) {
      dispatch({
        type: types.CREATE_STREET_LIGHT_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};

export const updateStreetLightAction = (request, uuid, callBack) => {
  return async (dispatch) => {
    dispatch(apiLoadingStart());
    dispatch({ type: types.UPDATE_STREET_LIGHT_REQUEST });
    try {
      const response = await ApiList.updateStreetLight(request, uuid);
      if (response) {
        dispatch({
          type: types.UPDATE_STREET_LIGHT_SUCCESS,
          payload: response,
        });
        if (callBack) callBack();

        toast.success(
          response.status === "ON"
            ? "Street light status updated to ON."
            : "Street light status updated to OFF."
        );
      } else {
        dispatch({
          type: types.UPDATE_STREET_LIGHT_ERROR,
          payload: response.status,
        });
      }
    } catch (error) {
      dispatch({
        type: types.UPDATE_STREET_LIGHT_ERROR,
        payload: error?.error || "An error occurred while fetching the profile",
      });
    } finally {
      dispatch(apiLoadingStop());
    }
  };
};
